import React from 'react';
import withStyles from '@mui/styles/withStyles';

export default withStyles({})(({ heading, children }) => {
    return (
        <div className="metric-content">
            <h3 className="metrics">{heading}</h3>
            {children}
        </div>
    );
});
